import React from "react";
import styled from "styled-components";
import theme from "../../../theme";

const { colors, fonts } = theme;

export const ParagraphContainer = styled.div`
  color: ${colors.secondary};
  font-family: ${fonts.heading};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;
ParagraphContainer.displayName = "Paragraph";

const Paragraph = ({ children }) => (
  <ParagraphContainer>{children}</ParagraphContainer>
);

export default Paragraph;
